import stockIds from './stock-ids';

export default {
  stockIds,
};
